import {
  GET_QUICK_SUMMARY,
  GET_QUICK_SUMMARY_SUCCESS,
  GET_QUICK_SUMMARY_FAILURE,
} from "../../action/types";

const INIT_STATE = {
  loading: false,
  quickSummaryDetails: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QUICK_SUMMARY:
      return { ...state, loading: true };
    case GET_QUICK_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        quickSummaryDetails: action.payload,
      };
    case GET_QUICK_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        quickSummaryDetails: action.payload,
      };
    default:
      return state;
  }
};
